import { retailProductAssistant } from './retail-product-assistant';
import { equipmentTroubleshooting } from './equipment-troubleshooting';
import { venueConcierge } from './venue-concierge';
import { interactiveExhibit } from './interactive-exhibit';

// Export all physical world playbooks
export const physicalWorldPlaybooks = [
  retailProductAssistant,
  equipmentTroubleshooting,
  venueConcierge,
  interactiveExhibit,
];

// Export individual playbooks for direct import
export { 
  retailProductAssistant,
  equipmentTroubleshooting,
  venueConcierge,
  interactiveExhibit
};